export default {
  queue: state => state.queue,
  years: state => state.years,
  makes: state => state.makes,
  languages: state => state.languages,
  status: state => state.status,
  answer: state => state.answer
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/dispatch/getters.js